
const Definition = {

    id: "sleeky",
    plan_level: 2,
    name: "Sleeky",
    path: "member/sleeky/components/Landing",
    preview_image: "https://img.freepik.com/free-vector/contour-line-background_53876-93503.jpg",
    colors: {
        background: "#ffffff",
        background_alt: "#f5f5f5",
        background_muted: "#dddddd",
        surface_dark: "#221f20",
        surface_dark_alt: "#2e2a2b",
        header_background: "#ffffff",
        text: "#221f20",
        text_inverse: "#ffffff",
        text_muted: "#6b6768",
        primary: "#e284a5",
        primary_dark: "#c9668a",
        success: "#22C55E",
        danger: "#EF4444"
    },
    legacy_color_keys: {
        background: "main_color1",
        background_alt: "main_color2",
        background_muted: "main_color3",
        surface_dark: "main_color4",
        surface_dark_alt: "main_color5",
        header_background: "header_bg",
        text: "text_color",
        text_inverse: "text_color_light",
        text_muted: "muted",
        primary: "primary_color",
        primary_dark: "primary_color_dark",
        success: "green",
        danger: "red"
    }

};

export default Definition;
